import { AxiosInstance } from 'axios';
import { globalStore } from '../main';
import { aopFactory } from './aop';
import { stringify } from 'qs';

import type { PluginFunction } from '@kastjs/runtime-core';
import { getCookie } from '../config';

export interface AxiosOptions {
  /**
   * axios 实例
   */
  instance?: AxiosInstance;
  /**
   * axios 启用请求拦截
   * @default true
   */
  enabledDefaultRequestInterceptors?: boolean;
  /**
   * axios 启用响应拦截
   * @default true
   */
  enabledDefaultResponseInterceptors?: boolean;
  /**
   * 不走网关的白名单
   * @default ['lcp.corp.kuaishou.com']
   */
  noCapiCases?: string[];
  /**
   * 自定义headers
   */
  subSystemName?: string;
}

interface ProfileInfo {
  redirectUrl?: string;
  result: number;
}

const axiosPlugin: PluginFunction<AxiosOptions> = async (context, options) => {
  const instance = options?.instance;
  // 白名单的域名不走网关
  const noCapiCases = Array.isArray(options?.noCapiCases)
    ? options?.noCapiCases
    : ['lcp.corp.kuaishou.com'];

  if (options?.enabledDefaultRequestInterceptors !== false) {
    // 拦截请求
    instance?.interceptors.request.use(config => {
      let { gatewayUrl, currentSubSystemName, isKimLeftSideBar } = globalStore.getAll();

      config.withCredentials = true;
      config.headers['Accept'] = 'application/json';
      const contentType = config.headers['Content-Type'] || '';
      if (contentType === 'multipart/form-data') {
        config.paramsSerializer = params => stringify(params);
      }

      const noCapi = noCapiCases.some(v => config.url?.includes(v));
      if (!noCapi) {
        config.headers['k-gate-referrer'] = window.location.href;

        // 添加网关地址
        if (gatewayUrl) config.baseURL = gatewayUrl;

        // 增加网关识别标示
        if (currentSubSystemName || options?.subSystemName) {
          config.headers['k-gate-origin-system'] = encodeURIComponent(
            options.subSystemName || currentSubSystemName
          );
        }
      }
      try {
        const mockReqHeaders = JSON.parse(getCookie('__kim_crm_mock_headers__'));
        // Kim 且 mockReqHeaders是对象
        if (
          isKimLeftSideBar &&
          mockReqHeaders &&
          Object.prototype.toString.call(mockReqHeaders) === '[object Object]'
        ) {
          const objEntries = Object.entries(mockReqHeaders);
          if (objEntries.length) {
            objEntries.forEach(item => {
              config.headers[item[0]] = item[1];
            });
          }
        }
      } catch (error) {
        console.log(error, 'Kim内添加自定义请求头失败了~');
      }
      return config;
    });
  }

  if (options?.enabledDefaultResponseInterceptors !== false) {
    // let { isKimLeftSideBar, env } = globalStore.getAll();
    instance?.interceptors.response.use(config => {
      const { result, redirectUrl }: ProfileInfo = config?.data || {};
      if (result === 303 || result === 302 || result === 307) {
        // if (isKimLeftSideBar && redirectUrl.includes('crm-auth.corp.kuaishou.com/register')) {
        //   window.location.href = ['beta', 'prt'].includes(env)
        //     ? 'https://crm-auth-beta.corp.kuaishou.com/no-permission'
        //     : 'https://crm-auth.corp.kuaishou.com/no-permission';
        // } else {
        //   window.location.href = redirectUrl || '';
        // }
        window.location.href = redirectUrl || '';
      }
      return config;
    });
  }
};

export const axiosPluginAOP = aopFactory(axiosPlugin, {});

export default axiosPlugin;
